import React from 'react'
import pure from 'recompose/pure'
import Button from 'aria-viewer/tour/components/buttons/button'
import playButtonSVG from 'public/assets/svg/icons/raw/icon_video_play_transparent.raw.svg'
import pauseButtonSVG from 'public/assets/svg/icons/raw/icon_video_pause_transparent.raw.svg'
import Style from 'style-it'
import { VIDEO_PLAY_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import { KEY_CODES } from 'aria-viewer/tour/constants/index'

const S = {
    innerContainer: { height: '100%' },
}

const VideoPlayButton = pure(function VideoPlayButton({
    isVideoPlaying,
    onClick,
    buttonStyle,
    theme,
    strokeWidth = 5.2,
    fill = 'rgb(41, 42, 58)',
}) {
    return (
        <Button
            tabIndex={VIDEO_PLAY_BUTTON_INDEX}
            onClick={onClick}
            id="play"
            keyboard={KEY_CODES.SPACE}
            style={buttonStyle}
            theme={theme}
        >
            <Style>
                {` .videoPlayButton svg use#Oval-51
			{
				stroke-width: '${strokeWidth}';
			}

			.videoPlayButton svg ellipse, .videoPlayButton svg circle#Oval-51
			{
				fill: '${fill}';
			}`}
            </Style>
            <div
                className="videoPlayButton"
                style={S.innerContainer}
                dangerouslySetInnerHTML={{
                    __html: isVideoPlaying ? pauseButtonSVG : playButtonSVG,
                }}
            />
        </Button>
    )
})

export default VideoPlayButton
